import React from 'react'
import SearchDashboard from '../../../Employer/SearchDashboard'

const Search = () => {
  return (
    <div>
      <SearchDashboard/>
    </div>
  )
}

export default Search
